import { MimeType } from 'vet-bones/constants';

import { ProjectPropertyType } from 'src/constants/project';
import { ModelSnapshot } from 'src/containers/ProjectDiagram/types/model';
import { newline } from 'src/templates/copy';
import { ExportToFileOptions } from 'src/utils/exportToFile';
import { stringifyModelConceptAttributes } from 'src/utils/stringify/modelConceptAttributes';
import { stringifyModelConceptClasses } from 'src/utils/stringify/modelConceptClasses';
import { stringifyModelConceptRelationships } from 'src/utils/stringify/modelConceptRelationships';
import { stringifyTurtleNamespaces } from 'src/utils/stringify/namespaces';
import { stringToFilename } from 'src/utils/stringToFilename';

export const exportModel = (
  name: string,
  model: ModelSnapshot,
  projectPropertyType: ProjectPropertyType,
  databaseNamespaces: Record<string, string>
): ExportToFileOptions => {
  const filename = `${stringToFilename(name)}.ttl`;
  const namespaces = stringifyTurtleNamespaces(databaseNamespaces);
  const classes = stringifyModelConceptClasses(model, databaseNamespaces);
  const relationships = stringifyModelConceptRelationships(
    model,
    projectPropertyType,
    databaseNamespaces
  );
  const attributes = stringifyModelConceptAttributes(
    model,
    projectPropertyType,
    databaseNamespaces
  );
  const contents =
    [namespaces, classes, relationships, attributes]
      .filter((str) => str)
      .join('\n\n') + newline;

  return { contents, filename, mimeType: MimeType.TURTLE };
};
